export const getStateFilters = (states) => {
  const filter = states?.map((entity) => ({
    label: entity.name,
    value: entity._id,
  }));
  const sortedFilter = filter?.sort((a, b) => a.label.localeCompare(b.label));
  return sortedFilter?.length ? [{ label: "All States", value: "" }, ...sortedFilter] : [];
};

export const getDistrictFilters = (districts) => {
  const filter = districts?.map((entity) => ({
    label: entity.city,
    value: entity._id,
  }));
  const sortedFilter = filter?.sort((a, b) => a.label.localeCompare(b.label));
  return sortedFilter?.length ? [{ label: "All Districts", value: "" }, ...sortedFilter] : [];
};

export const getAgencyFilters = (agencies) => {
  const filter = agencies?.map((entity) => ({
    label: entity.agencyName,
    value: entity._id,
  }));
  const sortedFilter = filter?.sort((a, b) => a.label.localeCompare(b.label));
  return sortedFilter?.length
    ? [{ label: "All Agencies", value: "" }, ...sortedFilter]
    : [];
};
export const getStatusFilters = (filterStatus) => {
  const filter = filterStatus?.map((entity) => ({
    label: entity.label,
    value: entity._id,
  }));
  const sortedFilter = filter?.sort((a, b) => a.label.localeCompare(b.label));
  return sortedFilter?.length ? [{ label: "All Status", value: "" }, ...sortedFilter] : [];
};

export const getProjectFilters = (projects) => {
  const filter = projects?.map((entity) => ({
    label: entity.projectCode,
    value: entity._id,
  }));
  const sortedFilter = filter?.sort((a, b) => 
  a.label.trim().toLowerCase().localeCompare(b.label.trim().toLowerCase())
);
  return sortedFilter?.length
    ? [{ label: "All Projects", value: "" }, ...sortedFilter]
    : [];
};

export const getSamplerFilters = (samplers) => {
  const filter =
    samplers?.map((entity) => ({
      label: entity.name,
      value: entity._id,
    })) || [];
  const sortedFilter = filter?.sort((a, b) => a.label.localeCompare(b.label));
  return sortedFilter?.length
    ? [{ label: "All Samplers", value: "" }, ...sortedFilter]
    : [];
};

export const getLogisticListFilters = (logistic) => {
  const filter =
    logistic?.map((entity) => ({
      label: entity.name,
      value: entity._id,
    })) || [];
  const sortedFilter = filter?.sort((a, b) => a.label.localeCompare(b.label));
  return sortedFilter?.length
    ? [{ label: "All Logistic", value: "" }, ...sortedFilter]
    : [];
};